/*
 * Public API Surface of ngx-image-mosaic
 */

export * from './lib/ngx-image-mosaic.component';
export * from './lib/ngx-image-mosaic.module';
export * from './lib/interfaces/input-parameters.interface';
export * from './lib/interfaces/frame.interface';
